import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/compare/splunk')({
  head: () => ({
    ...buildSeoHead({ path: '/compare/splunk', ...ROUTE_META['/compare/splunk'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Compare', path: '/compare' }, { name: 'Splunk', path: '/compare/splunk' }])),
      jsonLdScript(buildWebPageSchema({ path: '/compare/splunk', ...ROUTE_META['/compare/splunk'] })),
    ],
  }),
});
